import React from 'react';
import { useHistory } from 'react-router-dom';
import ShieldCheckIcon from '../../../ShieldCheckIcon';
import Toggle from '../../../Toggle';
import { hubPath } from '../../shared';
import { SPAM_LAYERS, TabProps } from './formSettingsData';

// sample count for the review line
const BLOCKED_THIS_MONTH = 22;

// Form settings › Spam protection (spec 713:5478): eight layers, the blocked words / domains, and the way to the held messages
const SpamProtection: React.FC<TabProps> = ({ form, setForm }) => {
    const history = useHistory();

    return <section className="card">
        <div className="section-title"><span className="icon-tile"><ShieldCheckIcon /></span><h2>Spam protection</h2></div>

        <div className="hub-fs-rows">
            {SPAM_LAYERS.map(l => <div key={l.key} className="setting-row">
                <div className="text"><div className="title">{l.label}</div><div className="hint">{l.hint}</div></div>
                <Toggle label={l.label} checked={form.spam[l.key]} onChange={on => setForm(f => ({ ...f, spam: { ...f.spam, [l.key]: on } }))} />
            </div>)}
        </div>

        <label className="field hub-fs-field">
            <span className="hub-fs-label">Blocked words</span>
            <input value={form.blockedWords} placeholder="Words or phrases, separated by commas"
                onChange={e => { const blockedWords = e.target.value; setForm(f => ({ ...f, blockedWords })); }} />
            <small className="hub-fs-help">Messages containing these go straight to blocked.</small>
        </label>
        <label className="field hub-fs-field">
            <span className="hub-fs-label">Blocked email domains</span>
            <input value={form.blockedDomains} placeholder="@example.com, separated by commas"
                onChange={e => { const blockedDomains = e.target.value; setForm(f => ({ ...f, blockedDomains })); }} />
        </label>

        <button type="button" className="link hub-fs-review" onClick={() => history.push(hubPath('contact-forms'))}>
            {BLOCKED_THIS_MONTH} messages blocked this month · View blocked
        </button>
    </section>;
};

export default SpamProtection;
